import { GroupModel, UserModel } from '$store/models';
import { useUserInfo } from '$hooks/useUserInfo';
import { useGroupInfo } from '$hooks/useGroupInfo';

export function useUnitInfo(unitId: number): UserModel | GroupModel {
  const user = useUserInfo(unitId);
  const group = useGroupInfo(-unitId);

  if (unitId > 0) {
    return user;
  } else {
    return group;
  }
}
